import {createAction} from 'redux-act';

export const windowIsNotInFocus = createAction('Window is not in focus now', (date) => ({date}));
export const windowIsInFocus = createAction('Window is now in focus', (date) => ({date}));
export const unreadMessageCountChanged = createAction('Unread Chat Message Count Changed', (conversationId, count) => ({conversationId, count}));